import { useState, useLayoutEffect, useRef } from "react"
import { useLocation, useNavigate, useLoaderData, useOutletContext } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import { lang } from "config"
import Form from "./form"
import { insertPurchaseOrder } from "helpers/transaction-helper" // ✅ buat helper ini

export default function Create({ title }) {
  const { user } = useAuth()
  const { cache } = useSWRConfig()
  const { setTransition } = usePage()
  const { setTitle } = useOutletContext()

  const data = useLoaderData()
  const location = useLocation()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  // Guard double-submit: cegah klik ganda mengirim PO dua kali.
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
    setTitle(`Create Purchase Order`)
  }, [])

  const handleSubmit = (payload) => {
    // payload sudah hasil build + validasi dari Form.
    if (submittingRef.current) return

    const onSuccess = (result, message) => {
      submittingRef.current = false
      setSubmitting(false)
      nProgress.done()
      cache.clear()

      toast.success(message || "PO berhasil disimpan!", { id: "submit" })

      // kalau API return id, arahkan ke edit
      const newId = result?.data?.id || result?.id
      if (newId) {
        navigate(`/purchase/${newId}/edit`, {
          replace: true,
          state: { back: title, from: location.pathname, transition: "slide" },
        })
      } else {
        navigate({ pathname: "/purchase" })
      }
    }

    const onError = (message, validationErrors) => {
      submittingRef.current = false
      setSubmitting(false)
      nProgress.done()
      // ATALLA-345: tampilkan error per-field (mis. po_number duplikat) di form,
      // bukan cuma toast generic.
      if (validationErrors && typeof validationErrors === "object") {
        setErrors(validationErrors)
      }
      toast.error(message || "Gagal simpan PO", { id: "submit" })
    }

    // ✅ Kalau masih mau validasi “header wajib” di container:
    if (!payload?.outlet_id || !payload?.supplier_id || !payload?.po_date) {
      setErrors({
        outlet_id: payload?.outlet_id ? undefined : lang.outlet_name + " " + lang.field_required,
        supplier_id: payload?.supplier_id ? undefined : lang.supplier_name + " " + lang.field_required,
        po_date: payload?.po_date ? undefined : "PO Date " + lang.field_required,
      })
      return
    }
    
    submittingRef.current = true
    setSubmitting(true)
    nProgress.start()
    toast.loading("Loading", { id: "submit" })
    insertPurchaseOrder(payload, user?.name, onSuccess, onError)
  }

  return (
    <Transition type="fade">
      <Form data={data} errors={errors} onSubmit={handleSubmit} submitting={submitting} />
    </Transition>
  )
}
